import angular from 'angular';
import {shopModule} from '../module.js';
import {AdrConstants} from '@nuskin/ns-shop';
import {RunConfigService} from '@nuskin/ns-util';
import {UserService} from '@nuskin/ns-account';
import {getCachedConfigField} from '@nuskin/configuration-sdk'

//Todo import nuskin.account

shopModule.factory('nsAdrOptions', ['$resource', '$q', function($resource, $q) {
    let mktGmtOffsets = {
        'AR': -3, 'AT':  1, 'AU': 10, 'BE':  1, 'BN':  8, 'BR': -3, 'CA': -7, 'CH':  1, 'CN':  8, 'CO': -5,
        'CR': -6, 'CZ':  1, 'DE':  1, 'DK':  1, 'ES':  1, 'EU':  1, 'FI':  2, 'FJ': 12, 'FR':  1, 'GB':  0,
        'GI':  1, 'GT': -6, 'HK':  8, 'HN': -6, 'HU':  1, 'ID':  7, 'IE':  0, 'IL':  2, 'IS':  0, 'IT':  1,
        'JP':  9, 'KR':  9, 'LU':  1, 'MO':  8, 'MX': -6, 'MY':  8, 'NC': 11, 'NL':  1, 'NO':  1, 'NZ': 12,
        'PF':  5, 'PH':  8, 'PL':  1, 'PT':  0, 'RO':  2, 'RU':  3, 'SE':  1, 'SG':  8, 'SK':  1, 'SV': -6,
        'TH':  7, 'TR':  2, 'TW':  8, 'UA':  2, 'US': -7, 'VE': -4, 'VN':  7, 'WO': -7, 'ZA':  2
    };

    Date.isLeapYear = function (year) {
        return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0));
    };

    Date.getDaysInMonth = function (year, month) {
        return [31, (Date.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
    };

    Date.prototype.isLeapYear = function () {
        return Date.isLeapYear(this.getFullYear());
    };

    Date.prototype.getDaysInMonth = function () {
        return Date.getDaysInMonth(this.getFullYear(), this.getMonth());
    };

    Date.prototype.addMonths = function (value) {
        let n = this.getDate();
        this.setDate(1);
        this.setMonth(this.getMonth() + value);
        this.setDate(Math.min(n, this.getDaysInMonth()));
        return this;
    };

    let eidObject = {};
    let user = UserService.getUser();
    if (user){
        eidObject = { eid: user.eid };
    }

    let blackoutDates = $resource((getCachedConfigField('shipDaysUrl')), {}, {
        get: {
            method: 'GET',
            headers: {'Content-Type': 'application/json',
                'client_id': RunConfigService.getRunConfig().clientId,
                'client_secret': RunConfigService.getRunConfig().clientSecret
            },
            data: eidObject,
            transformResponse: function(data) {
                return angular.fromJson(data);
            }
        }
    });

    let publicFunctions = {
        getOptions: function(adrOptions) {
            let deferred = $q.defer(),
                today = getDateObj(getNoonDate(adrOptions.get(AdrConstants.COUNTRY)));

            adrOptions.set(AdrConstants.TODAY, today);
            adrOptions.set(AdrConstants.CONTRACT_TYPE, AdrConstants.UNKNOWN);
            switch (adrOptions.get(AdrConstants.ADR_MODE)) {
                case AdrConstants.IMMEDIATE_FUTURE:
                    initImmediateFutureOptions(adrOptions, deferred);
                    break;
                case AdrConstants.DEFAULT_ALWAYS:
                    initDefaultAlwaysOptions(adrOptions, deferred);
                    break;
                case AdrConstants.IMMEDIATE_ONLY:
                    initImmediateOnlyOptions(adrOptions, deferred);
                    break;
                case AdrConstants.BASIC_OPTIONS:
                    initBasicOptions(adrOptions, deferred);
                    break;
            }
            return deferred.promise;

        }
    };

    function initImmediateFutureOptions(_adrOptions, _deferred) {
        let adrOptions = _adrOptions,
            deferred = _deferred;

        blackoutDates.get({
            market: adrOptions.get(AdrConstants.COUNTRY),
            qualifier: adrOptions.get(AdrConstants.QUALIFIER)
        })
            .$promise.then(function(response) {
                let disabledDates = response.ShipDaysResponse.blackoutDays,
                    blackoutPeriod = response.ShipDaysResponse.blackoutPeriod || 0,
                    tomorrow = getNoonDate(adrOptions.get(AdrConstants.COUNTRY)),
                    nextShipDate = getNextShipDate(adrOptions.get(AdrConstants.COUNTRY));

                tomorrow.setDate(tomorrow.getDate() + 1);

                // Handle available ship dates
                if (adrOptions.get(AdrConstants.FUTURE_DATES_NEXT_MONTH)) {
                    adrOptions.set(AdrConstants.AVAILABLE_SHIP_DATES, getAvailableShipDatesStartingNextMonth(disabledDates, blackoutPeriod, adrOptions.get(AdrConstants.COUNTRY)));
                } else {
                    adrOptions.set(AdrConstants.AVAILABLE_SHIP_DATES, getAvailableShipDatesStartingNow(getNoonDate(adrOptions.get(AdrConstants.COUNTRY)), disabledDates, blackoutPeriod, adrOptions.get(AdrConstants.COUNTRY)));
                }

                // Handle default recur date
                if ((adrOptions.get(AdrConstants.ADR_TYPE) || {}).value == AdrConstants.IMMEDIATE.value) {
                    // note that we need to set the day back first before advancing to next month...
                    nextShipDate.setDate(adrOptions.get(AdrConstants.TODAY).dayOfMonth);
                    nextShipDate = nextShipDate.addMonths(1);
                    if (isDayDisabled(nextShipDate.getDate(), disabledDates) ||
                        adrOptions.get(AdrConstants.USE_DFLT_FOR_IMMEDIATE_RECUR) ||
                        adrOptions.get(AdrConstants.USE_DFLT_FOR_IMMEDIATE_FIRST)) {

                        nextShipDate.setDate(response.ShipDaysResponse.defaultShipDay);
                        if (nextShipDate.getTime() < tomorrow.getTime()) {
                            nextShipDate.setMonth(nextShipDate.getMonth() + 1);
                        }
                    }
                    if (adrOptions.get(AdrConstants.ALLOW_SI_RECURRING_DATE_CHANGE)) {
                        // TODO: test this. I don't think there is an AVAILABLE_SHIP_DATES list base on code above.
                        nextShipDate.setDate(adrOptions.get(AdrConstants.AVAILABLE_SHIP_DATES)[0].dayOfMonth);
                    }
                } else {
                    if (isDayDisabled(nextShipDate.getDate(), disabledDates)) {
                        nextShipDate.setDate(response.ShipDaysResponse.defaultShipDay)
                    }
                }
                adrOptions.set(AdrConstants.DFLT_RECURRING_DT, getDateObj(nextShipDate));

                deferred.resolve(adrOptions);
            }).then(function() {
                deferred.reject('Failure in call to the ship-days service!');
            });
    }

    function initDefaultAlwaysOptions(_adrOptions, _deferred) {
        let adrOptions = _adrOptions,
            deferred = _deferred;

        blackoutDates.get({market: adrOptions.get(AdrConstants.COUNTRY), qualifier: adrOptions.get(AdrConstants.QUALIFIER), eid:user.eid})
            .$promise.then(function(response) {
                let disabledDates = response.ShipDaysResponse.blackoutDays,
                    blackoutPeriod = response.ShipDaysResponse.blackoutPeriod || 0,
                    tomorrow = getNoonDate(adrOptions.get(AdrConstants.COUNTRY)),
                    nextShipDate = getNextShipDate(adrOptions.get(AdrConstants.COUNTRY));

                tomorrow.setDate(tomorrow.getDate() + 1);

                if (adrOptions.get(AdrConstants.USE_DFLT_FOR_IMMEDIATE_RECUR) ||
                    adrOptions.get(AdrConstants.USE_DFLT_FOR_IMMEDIATE_FIRST)) {
                    nextShipDate.setDate(response.ShipDaysResponse.defaultShipDay);
                }

                // Handle available ship dates
                if ((adrOptions.get(AdrConstants.ADR_TYPE) || {}).value == AdrConstants.ALWAYS.value) {
                    if (adrOptions.get(AdrConstants.FUTURE_DATES_NEXT_MONTH)) {
                        adrOptions.set(AdrConstants.AVAILABLE_SHIP_DATES, getAvailableShipDatesStartingNextMonth(disabledDates, blackoutPeriod, adrOptions.get(AdrConstants.COUNTRY)));
                    } else {
                        adrOptions.set(AdrConstants.AVAILABLE_SHIP_DATES, getAvailableShipDatesStartingNow(getNoonDate(adrOptions.get(AdrConstants.COUNTRY)), disabledDates, blackoutPeriod, adrOptions.get(AdrConstants.COUNTRY)));
                    }
                }

                if (nextShipDate.getTime() < tomorrow.getTime()) {
                    nextShipDate.setMonth(nextShipDate.getMonth() + 1);
                }

                adrOptions.set(AdrConstants.DFLT_RECURRING_DT, getDateObj(nextShipDate));

                deferred.resolve(adrOptions);
            }).then(function() {
                deferred.reject('Failure in call to the ship-days service!');
            });
    }

    function initImmediateOnlyOptions(_adrOptions, _deferred) {
        let adrOptions = _adrOptions,
            deferred = _deferred;

        blackoutDates.get({market: adrOptions.get(AdrConstants.COUNTRY), qualifier: adrOptions.get(AdrConstants.QUALIFIER), eid:user.eid})
            .$promise.then(function(response) {
                let disabledDates = response.ShipDaysResponse.blackoutDays,
                    blackoutPeriod = response.ShipDaysResponse.blackoutPeriod || 0,
                    tomorrow = getNoonDate(adrOptions.get(AdrConstants.COUNTRY)),
                    nextShipDate = getNextShipDate(adrOptions.get(AdrConstants.COUNTRY));

                tomorrow.setDate(tomorrow.getDate() + 1);

                if (adrOptions.get(AdrConstants.USE_DFLT_FOR_IMMEDIATE_RECUR)) {
                    nextShipDate.setDate(response.ShipDaysResponse.defaultShipDay);
                }

                // Handle available ship dates
                if (adrOptions.get(AdrConstants.ALLOW_SI_RECURRING_DATE_CHANGE)) {
                    if (adrOptions.get(AdrConstants.FUTURE_DATES_NEXT_MONTH)) {
                        adrOptions.set(AdrConstants.AVAILABLE_SHIP_DATES, getAvailableShipDatesStartingNextMonth(disabledDates, blackoutPeriod, adrOptions.get(AdrConstants.COUNTRY)));
                    } else {
                        adrOptions.set(AdrConstants.AVAILABLE_SHIP_DATES, getAvailableShipDatesStartingNow(getNoonDate(adrOptions.get(AdrConstants.COUNTRY)), disabledDates, blackoutPeriod, adrOptions.get(AdrConstants.COUNTRY)));
                    }
                }

                if (nextShipDate.getTime() < tomorrow.getTime()) {
                    nextShipDate.setMonth(nextShipDate.getMonth() + 1);
                }

                adrOptions.set(AdrConstants.DFLT_RECURRING_DT, getDateObj(nextShipDate));

                deferred.resolve(adrOptions);
            }).then(function() {
                deferred.reject('Failure in call to the ship-days service!');
            });
    }

    function initBasicOptions(_adrOptions, _deferred) {
        let adrOptions = _adrOptions,
            deferred = _deferred;

        blackoutDates.get({market: adrOptions.get(AdrConstants.COUNTRY), qualifier: adrOptions.get(AdrConstants.QUALIFIER), eid:''}).$promise.then(function(response) {
            let disabledDates = response.ShipDaysResponse.blackoutDays,
                blackoutPeriod = response.ShipDaysResponse.blackoutPeriod || 0,
                nextShipDate = getNextShipDate(adrOptions.get(AdrConstants.COUNTRY));

            adrOptions.set(AdrConstants.AVAILABLE_SHIP_DATES, getAvailableShipDatesStartingNow(getNoonDate(adrOptions.get(AdrConstants.COUNTRY)), disabledDates, blackoutPeriod, adrOptions.get(AdrConstants.COUNTRY)));
            nextShipDate.setDate(response.ShipDaysResponse.defaultShipDay);
            adrOptions.set(AdrConstants.DFLT_RECURRING_DT, getDateObj(nextShipDate));
            deferred.resolve(adrOptions);
        }).then(function() {
            deferred.reject('Failure in call to the ship-days service!');
        });
    }

    function getAvailableShipDatesStartingNow(today, disabledDates, blackoutDays, cntryCd) {
        const blackoutDate = getNoonDate(cntryCd);

        // Set blackout date to N days after the current date
        blackoutDate.setDate(blackoutDate.getDate() + blackoutDays);

        return [...Array(31).keys()]
            // Create day-of-month list from 1 to 31 inclusive
            .map((n) => n + 1)
            // Remove the market's disabled days of month
            .filter((n) => !disabledDates.includes(n))
            // Convert day-of-month to Date set in current month
            .map((n) => {
                const date = getNoonDate(cntryCd);
                date.setDate(n);
                return date;
            })
            // If Date is before blackout date, advance it to next month
            .map((date) => {
                if (date <= blackoutDate) {
                    date.setMonth(date.getMonth() + 1);
                }
                return date;
            })
            // Convert Date to date information object
            .map(getDateObj);
    }

    function getAvailableShipDatesStartingNextMonth(disabledDates, blackoutDays, cntryCd) {
        let nextMonth = getNoonDate(cntryCd),
            blackoutDate = getNoonDate(cntryCd),
            availableDates = [],
            i;

        blackoutDate.setDate(blackoutDate.getDate() + blackoutDays);
        nextMonth.setMonth(nextMonth.getMonth() + 1);
        for (i = 1; i < getLastDayOfMonth(nextMonth); i++) {
            if (disabledDates.indexOf(i) < 0) {
                nextMonth.setDate(i);
                if (blackoutDate.getTime() < nextMonth.getTime()) {
                    availableDates.push(getDateObj(nextMonth));
                }
            }
        }
        return availableDates;
    }

    function getDateObj(date) {
        return {formatted: formatDateAsMountainIsoString(date), dayOfMonth: date.getDate(), month: date.getMonth() + 1, year: date.getFullYear()}
    }

    function isDayDisabled(day, disabledDates) {
        return disabledDates.indexOf(day) >= 0;
    }

    // Functions not used

    // function isDayEnabled(day, enabledDays) {
    //     let enabled = false;
    //     if (enabledDays) {
    //         angular.forEach(enabledDays, function(enabledDay) {
    //             if (day == enabledDay.dayOfMonth) {
    //                 enabled = true;
    //             }
    //         });
    //     }
    //     return enabled;
    // }

    // function getNextMonth(adrOptions, nextMonthDate) {
    //     let nextMonth = getNoonDate(adrOptions.get(AdrConstants.COUNTRY)),
    //         month = nextMonth.getMonth();

    //     nextMonth.setMonth(month < 11 ? month + 1 : 0);
    //     if (nextMonthDate) {
    //         nextMonth.setDate(nextMonthDate);
    //     }
    //     return nextMonth;
    // }

    // function getContractLengthObj(code, contractLength, monthsText) {
    //     return {value: code, displayText: contractLength + ' ' + monthsText};
    // }

    function getLastDayOfMonth(date) {
        return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    }

    function getNextShipDate(cntryCd) {
        let nextShipDate = getNoonDate(cntryCd),
            dayOfMonth = nextShipDate.getDate();

        if (dayOfMonth < getLastDayOfMonth(nextShipDate)) {
            nextShipDate.setDate(dayOfMonth + 1);
        }
        return nextShipDate;
    }

    function formatDateAsMountainIsoString(date) {
        // formats to YYYY-MM-DD
        let year = date.getFullYear(),
            day = date.getDate(),
            month = date.getMonth() + 1,
            hours = date.getHours(),
            mins = date.getMinutes();

        return year + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day + 'T'
            + (hours < 10 ? '0' : '') + hours + ':' + (mins < 10 ? '0' : '') + mins + ':00'
            + '-07:00';
    }

    // Functions not used

    // function formatDateYYYYMMdd(date) {
    //     // formats to YYYY-MM-DD
    //     let year = date.getFullYear(),
    //         day = date.getDate(),
    //         month = date.getMonth() + 1;

    //     return year + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day;
    // }

    // function formatDateMMMddYYYY(date) {
    //     let year = date.getFullYear(),
    //         day = date.getDate(),
    //         month = monthsMMM[date.getMonth()];

    //     return month + ' ' + day + ', ' + year;
    // }

    function getNoonDate(cntryCode, date) {
        let localDate = date ? new Date(date) : new Date(),
            localMillis,
            minuteMillis = 1000 * 60,
            hourMillis = 1000 * 60 * 60,
            hourOffset = mktGmtOffsets[cntryCode] ? mktGmtOffsets[cntryCode] : 0,
            utcOffsetMillis = hourOffset * hourMillis,
            offsetMillis,
            retDate;

        localDate.setHours(12, 0, 0, 0);    // base time is local noon time
        localMillis = localDate.getTime();
        offsetMillis = localMillis +
            (localDate.getTimezoneOffset() * minuteMillis) +    // get to UTC time
            utcOffsetMillis;                                    // get to market time
        retDate = new Date(offsetMillis);
        return retDate;
    }

    return publicFunctions;
}]);
